<template>
  <f7-page name="home">
    <wuju-navbar :menu="true" :back="false" title="Wuju" subtitle="be gentle with yourself"></wuju-navbar>
    <wuju-help-sheet page="home"></wuju-help-sheet>
    <f7-toolbar tabbar position="bottom">
      <f7-link tab-link="#tab-thoughts" :tab-link-active="$storage.settings.tab === 'thoughts'">Thoughts</f7-link>
      <f7-link tab-link="#tab-feelings" :tab-link-active="$storage.settings.tab === 'feelings'">Feelings</f7-link>
    </f7-toolbar>
    <wuju-quote ref="quoteBlock" :quotes="quotes"></wuju-quote>
    <f7-tabs>
      <f7-tab id="tab-thoughts" :tab-active="$storage.settings.tab === 'thoughts'"  v-on:tab:show="$storage.settings.tab = 'thoughts'">
        <wuju-thought-list :exiturl="exiturl"></wuju-thought-list>
      </f7-tab>
      <f7-tab id="tab-feelings" :tab-active="$storage.settings.tab === 'feelings'" v-on:tab:show="$storage.settings.tab = 'feelings'">
        <wuju-feeling-list categorize show-other :highlight="highlight" :exiturl="exiturl"></wuju-feeling-list>
      </f7-tab>
    </f7-tabs>
  </f7-page>
</template>

<style scoped>
  .video-thumb {
    width: 50px;
    float: right;
    margin: 0 0 10px 10px;
  }
</style>

<script>
import Utils from '../js/utils.js';
import Thoughts from '../js/thoughts.js';
import Sensations from '../js/sensations.js';
import Progress from '../js/progress.js';
import Quotes from '../js/quotes.js';
import Lessons from '../js/lessons.js';
import Narration from '../js/narration.js';

export default {
  props: {
    highlight: {
      type: Array,
      default: () => [],
    },
    play: {
      type: String,
      default: null
    },
    exiturl: {
      type: String,
      default: null
    }
  },
  data: function() {
    return {
      thoughts: Thoughts,
      sensations: Sensations,
      quotes: Quotes,
    }
  },
  methods: {
    showQuote() {
      this.$$(this.$refs.quoteBlock.$el).show();
    },
    hideQuote() {
      this.$$(this.$refs.quoteBlock.$el).hide();
    },
    ...Utils,
  },
  computed: {
    progress() {
      return Progress;
    },
    lessons() {
      return Lessons;
    },
    nextLesson() {
      for (var lesson of Object.values(Lessons)) {
        if (! this.$storage.lessons.get(lesson.key)) return lesson;
      }
    },
  },
  mounted() {
    Utils.clearObject(this.$store.intensity);
    if (this.play) {
      this.$nextTick(() => {
        Narration.play(this.play, 0, true);
      });
    }
  },
}
</script>